import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = ["innerHTML"]

import Duration from "@/guiide/ts/temporal/duration";
import { getDuration } from "@/guiide/ts/temporal/durationHelper";
import { ref, watch, computed } from "vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'DurationInYears',
  props: {
    duration: {
        type: Number,
        default: 0
    }
},
  setup(__props) {

const props = __props;

const durationForModel = ref<Duration>(new Duration(0, 0, 0, 0, 0));

watch(
  () => props.duration,
  (newDuration: number) => {
    durationForModel.value = getDuration(newDuration);
  }
)

const displayText = computed<string>(() => {
  if (durationForModel.value.isNonZeroButLessThanOneYear()) {
    return getFractionHtml();
  }

  const fractionHtml = getFractionHtml();
  
  return `${durationForModel.value.years} ${fractionHtml}`;
});

function getFractionHtml(): string {
  return durationForModel.value.hasFraction()
    ? `<sup>${durationForModel.value.numerator}</sup>/<sub>${durationForModel.value.denominator}</sub>`
    : "&nbsp;&nbsp;&nbsp;";
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("span", {
    class: "fw-bold",
    style: {"display":"inline-block","width":"2ch","text-align":"right"},
    innerHTML: displayText.value
  }, null, 8, _hoisted_1))
}
}

})